module.exports = __webpack_public_path__ + "static/media/2008.f0f6ca1e.svg";